<template>
  <v-form
  class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">Sign</h3>
    <v-layout>
      <v-flex md4 wrap>
        <v-select
            background-color="rgba(255,255,255)"
            v-model="certificateSelected"
            :items="certificateList"
            item-text="id"
            item-value="id"
            label="Select Certificate"
            @change="changeCertificate"
            outlined
            dense
        ></v-select>
        <v-layout>
          <v-flex>
            <v-text-field v-if="infoCredential?.PIN?.presence == 'true'"
                background-color="rgba(255,255,255)"
                v-model="PIN"
                label="PIN"
                dense
                outlined
            ></v-text-field>
            <v-text-field v-if="infoCredential?.OTP?.presence == 'true'"
                background-color="rgba(255,255,255)"
                v-model="OTP"
                label="OTP"
                dense
                outlined
            ></v-text-field>
            <v-text-field v-if="infoCredential?.EMAIL?.presence == 'true'"
                background-color="rgba(255,255,255)"
                v-model="EMAIL"
                label="EMAIL"
                dense
                outlined
            ></v-text-field>
            <v-text-field v-if="infoCredential?.SMS?.presence == 'true'"
                background-color="rgba(255,255,255)"
                v-model="SMS"
                label="SMS"
                dense
                outlined
            ></v-text-field>
            <v-text-field
                background-color="rgba(255,255,255)"
                v-model="text"
                label="DataToSign"
                dense
                outlined
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              background-color="rgba(255,255,255,0.2)"
              v-model="certificate"
              label="Certificate"
              dense
              outlined
          ></v-text-field>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <div class="mb-8"></div>

      </v-flex>
      <v-flex md2>
        <v-btn
            :disabled="!valid"
            color="#007CA4"
            dark
            @click="authorize">
          Authorize >>
        </v-btn>
      </v-flex>
      <v-flex md6 style="background-color: white">
        <vue-json-pretty :path="'res'" :data=this.response> </vue-json-pretty>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex md4 wrap>
        <v-select
          background-color="rgba(255,255,255)"
          v-model="format"
          :items="formatItems"
          label="Format"
          dense
          outlined
        ></v-select>
        <v-autocomplete
          background-color="rgba(255,255,255)"
          v-model="signAlgorithm"
          :items="signAlgorithmOPTIONS"
          label="Sign Algorithm"
          dense
          outlined
        ></v-autocomplete>
        <v-autocomplete
          background-color="rgba(255,255,255)"
          v-model="hashAlgorithm"
          :items="hashAlgorithmOPTIONS"
          label="Hash Algorithm"
          dense
          outlined
        ></v-autocomplete>
      </v-flex>
      <v-flex md2>
        <v-btn
            :disabled="response == null"
            color="#007CA4"
            dark
            @click="sign">
          Sign >>
        </v-btn>
      </v-flex>
      <v-flex md6 style="background-color: white">
        <vue-json-pretty :path="'res'" :data=this.responseSign> </vue-json-pretty>
      </v-flex>
    </v-layout>

  </v-form>
</template>
<script>

import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'
import alisonServer from  '../services/alisonServer.js';
import VueJsonPretty from 'vue-json-pretty';

  export default  {
    props: ['serverConfig'],
    components: {
      VueJsonPretty
    },
    data: () => ({
      text: 'sTOgwOm+474gFj0q0x1iSNspKqbcse4IeiqlDg/HWuI=',
      SADToken: '',
      PIN: '',
      OTP: '',
      SMS: '',
      EMAIL: '',
      infoCredential: null,
      dataToSignB64: null,
      certificate: null,
      certificateSelected: '',
      certificateList: [],
      signature: null,
      signAlgorithm: "1.2.840.113549.1.1.1",
      hashAlgorithm: "2.16.840.1.101.3.4.2.1",
      valid: true,
      format: null,
      params: null,
      formatItems: [],
      keystoresOPTIONS: [],
      signAlgorithmOPTIONS: ["1.2.840.113549.1.1.1"],
      hashAlgorithmOPTIONS: ["2.16.840.1.101.3.4.2.1"],
      profileOPTIONS: [],
      requestPayload: '{}',
      response: null,
      responseSign: null,
    }),
    async mounted(){
      this.formatItems = Object.values(alisonJS.getServerSignFormats())
      const credentials = await alisonServer.listCredentials();
      this.certificateList = credentials.map(c => ({ id: c }))
      console.log(credentials);
    },
    watch: {
      infoCredential(value) {
        console.log(value, "changed");
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      async authorize() {
        const sadToken = await alisonServer.authorize({
          credentialId: this.certificate,
          numSignatures: 1,
          hash: [this.text],
          PIN: this.PIN != '' ? this.PIN : null,
          OTP: this.OTP != '' ? this.OTP : null,
          SMS: this.SMS != '' ? this.SMS : null,
          EMAIL: this.EMAIL != '' ? this.EMAIL : null,
        });
        this.response = sadToken
        this.SADToken = sadToken.SAD
      },
      async changeCertificate(cert){
        const info = await alisonServer.certificateInfo(cert)
        this.infoCredential = info
        this.certificate = cert
      },
      async sign() {
        const result = await alisonServer.signHash({
          credentialId: this.certificate,
          SAD: this.SADToken,
          hash: [this.text],
          hashAlgo: this.hashAlgorithm,
          signAlgo: this.signAlgorithm,
          signFormat: this.format,

        })
        this.responseSign = result;
        this.signature = JSON.stringify(result,null, "\t");
      },
    },
  }
</script>
<style scoped>
  .v-expansion-panel-header{
    background-color: #007CA4;
  }
</style>
